module.exports = __webpack_public_path__ + "d664201f/img/comments-icon.fdec7fdb.svg";